import { searchTableActions } from '../actions'
const { CHANGE_TERM, CLEAR_TERM, CHANGE_FILTER, CLEAR_FILTER } = searchTableActions

const initialState = {
  term: '',
  filter: {}
}

const searchTable = (state = initialState, action = {}) => {
  switch (action.type) {
    case CHANGE_TERM:
      return {
        ...state,
        term: action.term || ''
      }
    case CLEAR_TERM:
      return {
        ...state,
        term: ''
      }
    case CHANGE_FILTER:
      return {
        ...state,
        filter: action.filter
      }
    case CLEAR_FILTER:
      return {
        ...state,
        filter: {}
      }
    default:
      return state
  }
}

export default searchTable



// WEBPACK FOOTER //
// ./src/reducers/searchTable.js